import {AfterViewInit, Component, ElementRef, EventEmitter, Output} from "@angular/core";
import * as EXIF from 'exif-js/exif';
import {Croppie} from 'croppie';

@Component({
  selector: 'profile-avatar-image',
  template: ''
})
export class ProfileAvatarImageComponent implements AfterViewInit {

  @Output() public onNewImage = new EventEmitter<Blob>();

  public croppie: Croppie;
  public cropAvatar: HTMLDivElement;

  constructor(elementRef: ElementRef) {
    this.cropAvatar = elementRef.nativeElement;
    this.croppie = elementRef.nativeElement;
    (<any>window).EXIF = EXIF;
  }

  croppieOptions = {
    viewport: {
      width: 240,
      height: 240,
      type: 'circle'
    },
    enableExif: true,
    boundary: {
      width: 300,
      height: 300
    }
  };

  ngAfterViewInit() {
    this.croppie = new Croppie(this.cropAvatar, this.croppieOptions);
  }

  ngOnDestroy() {
    this.croppie.destroy();
  }

  readFileWithExif(input) {
    let fileReader = new FileReader();

    fileReader.onloadend = () => {
      this.croppie.bind(fileReader.result);
    };
    fileReader.readAsDataURL(input);
  }

  readFile(input) {
    EXIF.getData(input, this.readFileWithExif(input));
  }

  getImage() {
    this.croppie.result({
      size: {
        width: 512,
        height: 512
      },
      circle: false,
      type: 'blob',
      format: 'jpeg',
      quality: 0.75
    }).then((resp) => {
      this.onNewImage.emit(resp);
    });
  }

  reset() {
    this.croppie.destroy();
    this.croppie = new Croppie(this.cropAvatar, this.croppieOptions);
  }
}
